import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type RequestRefuseTranslationReviewDTO = {
  translationId: number;
  refuseReason: string;
};

// refuse a translation review phase
export const refuseTranslationReview = async (data: RequestRefuseTranslationReviewDTO): Promise<Translation> => {
  const response = await axiosInstance.post<{ data: Translation }>(`/api/translation/phase/refuse-review`, data);
  return response.data.data;
};
